/* eslint-disable @typescript-eslint/no-unused-vars */
import { AccessIssueSolutionGroup, AccessIssueSolutionLabel } from '@acp/shared';
import { VStack } from '@chakra-ui/react';
import { NotifyDIForm, CallTenantForm, SendOccupantNotificationForm } from '../../../../components/forms';
import { AccessIssuesWizardSolutionProps } from './types';
import { TenancyForm } from '../../../tenancy';
import { BookingForm } from '../../../active-notice/components/booking-modal/booking-form';
import { UpdateEntryMethodForm } from '../../../active-notice/components/entry-method-modal/update-entry-method-form';
import { EditIntegratedPropertyForm, EditPropertyForm } from '../../../property';

export function AccessIssuesWizardSolutionRenderer(
    props: AccessIssuesWizardSolutionProps
) {
    const {
        propertyId,
        onAgencyAction,
        entryMethod,
        solution,
        problemSet,
        isPropertyIntegrated,
        softwareName,
        caseDetails,
    } = props;

    let confirmButtonText = isPropertyIntegrated != null && isPropertyIntegrated === true
        ? solution.confirmation_button_text_integrated
        : solution.confirmation_button_text_non_integrated;

    confirmButtonText = confirmButtonText.replace('{PMS}', softwareName ?? '');

    const tenantFromRequiredTypes = [
        AccessIssueSolutionLabel.AddTenantDetails,
        AccessIssueSolutionLabel.UpdateTenantDetails,
        AccessIssueSolutionLabel.ConfirmTenantDetails,
        AccessIssueSolutionLabel.ConfirmVacantTenantDetails,
        AccessIssueSolutionLabel.AddEmail,
        AccessIssueSolutionLabel.AddAdditionalPointOfContact,
        AccessIssueSolutionLabel.MakeTenantDetailsAccurate,
    ];

    if (tenantFromRequiredTypes.indexOf(solution.solution_label) >= 0) {
        return (
            <TenancyForm
                propertyId={propertyId}
                onTenancyConfirmed={() => onAgencyAction()}
                formType={solution.solution_label}
                confirmButtonText={confirmButtonText}
            />
        );
    }

    if (solution.solution_label === AccessIssueSolutionLabel.VerifyGoodKey) {
        if (isPropertyIntegrated === false) {
            return (
                <EditPropertyForm
                    propertyId={propertyId}
                    onClose={() => {}}
                    onUpdatedProperty={() => onAgencyAction()}
                    showHeader={false}
                    showCloseButton={false}
                    p={0}
                    enforceValidKey
                    confirmButtonText={confirmButtonText}
                    showOnsiteKeyFields={false}
                />
            );
        }
        return (
            <EditIntegratedPropertyForm
                propertyId={propertyId}
                onClose={() => {}}
                onUpdatedProperty={() => onAgencyAction()}
                showHeader={false}
                showCloseButton={false}
                p={0}
                confirmButtonText={confirmButtonText}
                showOnsiteKeyFields={false}
            />
        );
    }

    if (solution.solution_label === AccessIssueSolutionLabel.VerifyKeyOnsite) {
        if (isPropertyIntegrated === false) {
            return (
                <EditPropertyForm
                    propertyId={propertyId}
                    onClose={() => {}}
                    onUpdatedProperty={() => onAgencyAction()}
                    showHeader={false}
                    showCloseButton={false}
                    p={0}
                    enforceValidKey={false}
                    confirmButtonText={confirmButtonText}
                    showAgencyKeyFields={false}
                />
            );
        }
        return (
            <EditIntegratedPropertyForm
                propertyId={propertyId}
                onClose={() => {}}
                onUpdatedProperty={() => onAgencyAction()}
                showHeader={false}
                showCloseButton={false}
                p={0}
                confirmButtonText={confirmButtonText}
                showAgencyKeyFields={false}
            />
        );
    }

    if (solution.solution_label === AccessIssueSolutionLabel.AgencyEmail) {
        return (
            <SendOccupantNotificationForm
                confirmButtonText={confirmButtonText}
                propertyId={propertyId}
                onNotificationSent={(notes) => onAgencyAction({ notes })}
            />
        );
    }

    if (solution.solution_label === AccessIssueSolutionLabel.SpeakWithTenant) {
        return (
            <CallTenantForm
                confirmButtonText={confirmButtonText}
                propertyId={propertyId}
                onTenantCalled={(notes) => onAgencyAction({ notes })}
            />
        );
    }

    if (solution.solution_label === AccessIssueSolutionLabel.ManuallyBookInJobForTenant) {
        return (
            <BookingForm
                confirmButtonText={confirmButtonText}
                propertyId={propertyId}
                onBookingCreated={() => onAgencyAction()}
                onClose={() => {}}
                enableCloseButton={false}
                overrideBookableServices={caseDetails.oas_bookable_services}
            />
        );
    }

    if (solution.solution_group === AccessIssueSolutionGroup.NotifyDI
        || solution.solution_group === AccessIssueSolutionGroup.NotifyDIWithNotes
        || solution.solution_group === AccessIssueSolutionGroup.NotifyDIWithDate) {
        return (
            <NotifyDIForm
                confirmButtonText={confirmButtonText}
                problemSet={problemSet}
                propertyId={propertyId}
                onConfirmed={onAgencyAction}
                requireNotes={
                    solution.solution_group === AccessIssueSolutionGroup.NotifyDIWithNotes
                }
                requireDate={
                    solution.solution_group === AccessIssueSolutionGroup.NotifyDIWithDate
                }
            />
        );
    }

    const updateEntryMethodRequireTypes = [
        AccessIssueSolutionLabel.AllowAllFormsOfEntry,
        AccessIssueSolutionLabel.AllowEntryAppt,
        AccessIssueSolutionLabel.AllowEntryEnInternal,
        AccessIssueSolutionLabel.AllowEntryTRKP,
        AccessIssueSolutionLabel.AllowEntryVacant,
    ];

    if (updateEntryMethodRequireTypes.indexOf(solution.solution_label) >= 0) {
        return (
            <UpdateEntryMethodForm
                confirmButtonText={confirmButtonText}
                propertyId={propertyId}
                entryMethodField={entryMethod}
                onEntryMethodUpdated={(notes) => onAgencyAction({ notes })}
            />
        );
    }

    return null;
}
